import { FC } from "react";

import { Box } from "@mui/material";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";
import { useTranslate } from "@/hooks/useTranslate";

export const GeneratingBannerPlaceholder: FC = () => {
  const { t } = useTranslate();

  return (
    <Box
      sx={{
        width: "100%",
        aspectRatio: "16 / 9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: (theme) => theme.palette.surface.neutral.supershy,
      }}
    >
      <DashboardTypography variant="caption" vibe="text-neutral-quiet">
        {t("common", "yourBannerWillShowHere")}
      </DashboardTypography>
    </Box>
  );
};
